import React from "react";

const CourseDetailsTabs = ({ tabs, setTabs, section }) => {
  return (
    <>
      <div className="flex w-full overflow-auto">
        <div className="flex whitespace-nowrap border-b border-[#E0E0E0] w-fit">
          <p
            className={`cursor-pointer py-4 px-[20px] text-[14px] leading-[14px] ${
              tabs === "about" || tabs === "learn" || tabs === "project"
                ? "border-b border-[#F8D210] border-b-[5px] font-medium"
                : ""
            }`}
            onClick={() => setTabs("about")}
          >
            {section === "ShortCourse"
              ? "About"
              : section === "project"
                ? "Project Description"
                : "Learn"}
          </p>
          {section !== "project" && (
            <p
              className={`cursor-pointer py-4 px-[20px] text-[14px] leading-[14px] ${
                tabs === "curriculum" &&
                "border-b border-[#F8D210] border-b-[5px] font-medium"
              }`}
              onClick={() => setTabs("curriculum")}
            >
              Curriculum
            </p>
          )}

          {section === "project" && (
            <p
              className={`cursor-pointer py-4 px-[20px] text-[14px] leading-[14px] ${
                tabs === "deliverables" &&
                "border-b border-[#F8D210] border-b-[5px] font-medium"
              }`}
              onClick={() => setTabs("deliverables")}
            >
              Deliverables
            </p>
          )}
          <p
            className={`cursor-pointer py-4 px-[20px] text-[14px] leading-[14px] ${
              tabs === "resources" &&
              "border-b border-[#F8D210] border-b-[5px] font-medium"
            }`}
            onClick={() => setTabs("resources")}
          >
            Resources
          </p>
          {section === "project" && (
            <p
              className={`cursor-pointer py-4 px-[20px] text-[14px] leading-[14px] ${
                tabs === "meetings" &&
                "border-b border-[#F8D210] border-b-[5px] font-medium"
              }`}
              onClick={() => setTabs("meetings")}
            >
              Meetings
            </p>
          )}
          {section === "project" && (
            <p
              className={`cursor-pointer py-4 px-[20px] text-[14px] leading-[14px] ${
                tabs === "mentor" &&
                "border-b border-[#F8D210] border-b-[5px] font-medium"
              }`}
              onClick={() => setTabs("mentor")}
            >
              Mentor
            </p>
          )}

          {section !== "project" && (
            <p
              className={`cursor-pointer py-4 px-[20px] text-[14px] leading-[14px] ${
                tabs === "ratings" &&
                "border-b border-[#F8D210] border-b-[5px] font-medium"
              }`}
              onClick={() => setTabs("ratings")}
            >
              Ratings
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default CourseDetailsTabs;
